import { Link } from "react-router-dom";
import { HandHeart, ArrowRight } from "lucide-react";
import { causeForNews } from "../../lib/volunteerVisuals";

export const LocalActionCTA = ({ topics, onNavigate }) => {
  const cause = causeForNews(topics);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4" data-testid="local-action-cta">
      <div className="flex items-start gap-3">
        <HandHeart size={22} className="mt-0.5 shrink-0 text-emerald-700" />
        <div><p className="font-semibold text-slate-900">What can I do locally? <span className="font-normal text-slate-600">· From Headlines to Helping Hands</span></p>
          <p className="text-sm text-slate-600">Explore {cause} volunteer opportunities in your community.</p></div>
      </div>
      <Link to={`/volunteer?category=${encodeURIComponent(cause)}`} onClick={onNavigate} className="btn-green inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold" data-testid="local-action-cta-link">
        Find opportunities <ArrowRight size={15} />
      </Link>
    </div>
  );
};
